import PDCSection from '../../pages/ProductionPage/PDCSection';
// import PressShop from '../../pages/ProductionPage/PressShop';
import PressShopSection from '../../pages/ProductionPage/PressShopSectionIdeal';
import { Profile } from '../../pages/profile';

interface routes {
  path: string;
  element: JSX.Element;
  errorElement?: string;
}

export const other: routes[] = [
  {
    path: 'profile',
    element: <Profile />,
  },
  {
    path: 'pdc',
    element: <PDCSection />,
  },
  {
    path: 'production/pressShop',
    element: <PressShopSection />,
  },
  // {
  //   path: 'pressShop',
  //   element: <PressShop />,
  // },
];
